import React, { useEffect, useState,useRef,useContext} from 'react';
import $ from 'jquery';
import axios from 'axios';
import apiurl from '../Api';
import Swal from 'sweetalert2';
import CreatePassword from './css/show-password';
import Select from 'react-select';
import qs from 'qs';
import RefreshContext from './RefreshContext';
import { useNavigate } from 'react-router-dom';
import VendorCopy from './vendorcopy';
function Sub_category() {
  
  const { refreshKey } = useContext(RefreshContext);

  const [staff, setStaff] = useState([]);
  const [app, setApp] = useState([]);
  const passwordVisibility = CreatePassword('password');
  const passwordVisibility2 = CreatePassword('confirm');
  const [changes, setChanges] = useState({});
  const [postFilter, setPostFilter] = useState(null);
const [filteredStaff, setFilteredStaff] = useState(staff);
  const [userss,setUsername] = useState("");
  const [searchText, setSearchText] = useState("");
  const searchRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [sid,setUserID] = useState(0);
  const [selectedpost,setPost] = useState(null);

  const [selectedPost, setSelectedPost] = useState(null);
  const [userOptions, setUserOptions] = useState([]);
  const [statusData, setStatusData] = useState(false);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState([]); // for API
  const [uniquepost,setDesign] = useState([]);
  const navigate = useNavigate();
  const vendorAid = 109;
  const [stats,setStats]= useState([]);

    const [baBankAccountNo, setBaBankAccountNo] = useState("");
    const [baIfscCode, setBaIfscCode] = useState("");
    const [baServiceCategory, setBaServiceCategory] = useState(null);
    const [baSharingRatio, setBaSharingRatio] = useState(null);

  const serviceCategoryOptions = [
    { value: "lead_generation_only", label: "Lead Generation Only", description: "Convertible Lead Provided", thumbText: "LG", thumbBg: "#0ea5e9", ratioValue: "5_00_ba_share_1_year" },
    { value: "account_management", label: "Account Management", description: "Client Onboarding + CRM Assistance", thumbText: "AM", thumbBg: "#22c55e", ratioValue: "5_00_ba_share_2_years" },
    { value: "partial_sourcing", label: "Partial Sourcing", description: "Stipend-only OR <50% Candidates Sourced", thumbText: "PS", thumbBg: "#f59e0b", ratioValue: "20_00_ba_share" },
    { value: "comprehensive_services", label: "Comprehensive Services", description: "Lead Gen + Pitching + CRM", thumbText: "CS", thumbBg: "#ef4444", ratioValue: "50_00_ba_share" }
  ];
  const sharingRatioOptions = [
    { value: "5_00_ba_share_1_year", label: "5.00 BA Share (1 Year)", description: "Lead Generation Only", thumbText: "5%", thumbBg: "#0ea5e9" },
    { value: "5_00_ba_share_2_years", label: "5.00 BA Share (2 Years)", description: "Account Management", thumbText: "5%", thumbBg: "#22c55e" },
    { value: "20_00_ba_share", label: "20.00 BA Share", description: "Partial Sourcing", thumbText: "20%", thumbBg: "#f59e0b" },
    { value: "50_00_ba_share", label: "50.00 BA Share", description: "Comprehensive Services", thumbText: "50%", thumbBg: "#ef4444" }
  ];
  const isBusinessAssociate = selectedpost?.value === "business_associate";
  const resetBusinessAssociateFields = () => {
    setBaBankAccountNo("");
    setBaIfscCode("");
    setBaServiceCategory(null);
    setBaSharingRatio(null);
  };
  const formatSelectWithThumb = (option) => (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <span
        style={{
          width: "30px",
          height: "30px",
          borderRadius: "6px",
          backgroundColor: option.thumbBg,
          color: "#fff",
          fontSize: "11px",
          fontWeight: 700,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        {option.thumbText}
      </span>
      <div>
        <div style={{ fontSize: "13px", fontWeight: 600 }}>{option.label}</div>
        <div style={{ fontSize: "11px", opacity: 0.75 }}>{option.description}</div>
      </div>
    </div>
  );

  const fetchData = async () => {
    const response = await axios.get(apiurl + 'staff.php?subdomain=react'); // Replace with your API endpoint
    if(response.data.status==false){
       Swal.fire({
        position: "top-center",
        icon: "error",
        title: response.data.message,
        showConfirmButton: false,
        timer: 2000
       });
        return false;
   }
     setDesign(response.data.posts || []);
     setStats(response.data.stats || []);
    setStaff(response.data.staff);
  };
 
  // Debounce function
  function debounce(fn, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  useEffect(() => {
    document.title = "Staff | MERAQUI";
    fetchData();
    $('#modalclose').on('click', function () {
      $("#hidden").val("");
      $("#reset").click();
      setPost(null);
      setSelectedUsers([]);
      setSelectedUserIds([]);
      setStatusData(false);
      setUserOptions([]);
      resetBusinessAssociateFields();
    });


    $('.appCloseModal').on('click', function () {
      setApp([]);
      setUserID("");
    });
    searchRef.current = debounce((value) => {
      setLoading(true);

      setTimeout(() => {
        const items = document.querySelectorAll(".staff-card"); // <-- wrap each staff in this class
        let found = false;

        items.forEach((item) => {
          const text = Array.from(
            item.querySelectorAll(".search-value") // search in all elements with search-value
          )
            .map((el) => el.textContent?.toLowerCase() || "")
            .join(" ");

          const match = text.includes(value);
          item.style.display = match ? "block" : "none";
          if (match) found = true;
        });

        document.getElementById("noDataMessage").style.display = found
          ? "none"
          : "block";

        setLoading(false);
      }, 300);
    }, 300);

  }, [refreshKey]);

useEffect(() => {

 if(!postFilter){
   setFilteredStaff(staff);
 }else{

   const filtered = staff.filter(s => {

     const staffPost = s.post
       ?.toLowerCase()
       .replace(/\s+/g, "_");
     return staffPost === postFilter.value;

   });
   
   
   setFilteredStaff(filtered);
 }

}, [postFilter, staff]);

  const handleChange = (e) => {
    const value = e.target.value.toLowerCase().trim();
    setSearchText(value);
    searchRef.current(value);
  };

  // form submit in category
  const FormSubmit = async (e) => {
    e.preventDefault();

    if ($("#password").val()!=$("#confirm").val()) {
      Swal.fire({
        position: "top-center",
        title: "Password and Confirm Password not match",
        icon: "question"
      });
      return false;
    }

      if (!selectedpost?.value) {
          Swal.fire({
            position: "top-center",
            title: "Please select designation",
            icon: "question"
          });
          return false;
        }

        if (isBusinessAssociate) {
          if (!baBankAccountNo.trim() || !baIfscCode.trim() || !baServiceCategory?.value || !baSharingRatio?.value) {
            Swal.fire({
              position: "top-center",
              title: "Please fill all Business Associate fields",
              icon: "question"
            });
            return false;
          }
          if (!/^\d{9,18}$/.test(baBankAccountNo.trim())) {
            Swal.fire({
              position: "top-center",
              title: "Bank Account No. should be 9 to 18 digits",
              icon: "question"
            });
            return false;
          }
          if (!/^[A-Z]{4}0[A-Z0-9]{6}$/i.test(baIfscCode.trim())) {
            Swal.fire({
              position: "top-center",
              title: "Invalid IFSC format",
              icon: "question"
            });
            return false;
          }
        }

   $("#showLoader").removeClass('d-none').addClass('d-flex');
    try {
       const formData = new FormData(e.target);
       formData.append("post", selectedpost?.value || '');
        formData.append("bank_account_no", isBusinessAssociate ? baBankAccountNo.trim() : "");
       formData.append("ifsc_code", isBusinessAssociate ? baIfscCode.trim().toUpperCase() : "");
       formData.append("service_category", isBusinessAssociate ? baServiceCategory?.value || "" : "");
       formData.append("sharing_ratio", isBusinessAssociate ? baSharingRatio?.value || "" : "");
       
       formData.append("under", selectedpost?.value === "cxo" || selectedpost?.value === "sourcing_manager" || selectedpost?.value === "sourcing_head" || selectedpost?.value === "executive_manager" ? selectedUserIds.join(",") : selectedUserIds[0] || "");
       const response = await axios.post(apiurl + "staff.php", formData);
       
      if (response.data.status === true) {
        Swal.fire({
          position: "top-center",
          icon: "success",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        }).then(() => {
          $("#modalclose").click();
          fetchData();
        });
       
       }
      else {
        Swal.fire({
          position: "top-center",
          icon: "error",
          title: response.data.message,
          showConfirmButton: false,
          timer: 2000
        });
      }
    } catch (error) {
      console.log(error.response?.data?.message); // Handle errors with informative messages
    }
    $("#showLoader").removeClass('d-flex').addClass('d-none');
  };

  // delete the data from the category
  const DeleteData = async (id) => {
    if (!id) { return false; }
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this data!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      try {
        const response = await axios.get(apiurl + "staff.php?del=" + id);
        if (response.data.status == true) {
          Swal.fire({
            position: "top-center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 2000
          }).then(() => {
            fetchData();
          });

        }
        else {
          console.log(response.data.message);
        }
      }
      catch (error) {
        console.error('Error deleting category:', error);
      }


    }

  };
  //edit the form
  const EditData = async (edit) => {
    if (edit) {

      $("#showLoader").removeClass('d-none').addClass('d-flex');
      try {
        const response = await axios.get(apiurl + 'staff.php?edit=' + edit);

        if (response.data.status == true) {
        
          $("#name").val(response.data.data[0].name);
          $("#email").val(response.data.data[0].email);
          
          const postValue = response.data.data[0].post;
          const selectedPostOption = uniquepost.find(opt => opt.value === postValue) || null;
          setPost(selectedPostOption);
          await handleDesignationChange(selectedPostOption);
          setSelectedUsers(response.data.data[0].selectedUsers);

          setSelectedUserIds((response.data.selectedUsers || []).map((u) => String(u.value).split(";")[0]));
          setBaBankAccountNo(response.data.bank_account_no || "");
          setBaIfscCode(response.data.ifsc_code || "");
          setBaServiceCategory(serviceCategoryOptions.find((opt) => opt.value === (response.data.service_category || "")) || null);
          setBaSharingRatio(sharingRatioOptions.find((opt) => opt.value === (response.data.sharing_ratio || "")) || null);
          
          $("#mobile").val(response.data.data[0].phone);
          $("#password, #confirm").val(response.data.data[0].passkey);
          $("#hidden").val(response.data.data[0].hidden);
          // $("#wpasskey").val(response.data.data[0].wpasskey);
          // $("#wcustomerKey").val(response.data.data[0].wcustomerKey);
      
          $('#addStaffbtn').click();
          $("#showLoader").removeClass('d-flex').addClass('d-none');
        } else {
          // modal can't show
          alert("data not found");
        }

      }
      catch (error) {
        console.error('Error deleting category:', error);
      }

    }

  };

  const Access = async (sid) => {
    $("#showLoader").removeClass('d-none').addClass('d-flex');
    try {
      const response = await axios.get(apiurl + 'access.php?subdomain=react&sid=' + sid);
      setApp(response.data.access);
     
      setUserID(response.data.id);
      setUsername(response.data.namess.toUpperCase());
      $("#tera_modal").click();
      $("#showLoader").removeClass('d-flex').addClass('d-none');

    }
    catch (error) {
     // console.log(error?response?data?.message);
    }


  };

  const handleToggle = async (appid, checked, type) => {
    const value = checked ? 1 : 0;
    
    const key = type == 1 ? "add" : type == 2 ? "edit" : type == 3 ? "del" : "view";
    setChanges((prev) => ({ ...prev, [`${appid}_${key}`]: checked }));
    
    try {
      const response = await axios.post(apiurl + "access.php", new URLSearchParams({
        value: value,
        sid: sid,
        app: appid,
        type: type
      }), {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
      });
      console.log(response.data.message);

    } catch (error) {
      console.log(error.response?.data?.message);
    }
  };

  const handleDesignationChange = async (option) => {
  setPost(option);
    setSelectedPost(option);
    const postValue = option ? option.value : null;
    if (postValue !== "business_associate") {
      resetBusinessAssociateFields();
    }
    if (postValue) {
      $("#showLoader").removeClass('d-none').addClass('d-flex');
      try {
        const response = await axios.post(apiurl + "staff.php", qs.stringify({ designation: postValue }), {
        headers: {
              "Content-Type": "application/x-www-form-urlencoded"
         }
        });
        $("#showLoader").removeClass('d-flex').addClass('d-none');
        
        const { users, statusdata } = response.data;
        setStatusData(statusdata);
        if (statusdata) {
          const formattedUsers = users.map((u) => ({
            value: u.id,
            label: u.name,
          }));
          setUserOptions(formattedUsers);
        } else { setUserOptions([]); setSelectedUsers([]);}
      
      } catch (error) {
        console.error("API Error:", error);
        $("#showLoader").removeClass('d-flex').addClass('d-none');
      }
    } else {
      setStatusData(false);
      setUserOptions([]);
      setSelectedUsers([]);
    }
  };

  const handleUserChange = (selected) => {
  setSelectedUsers(selected); // always store object/array for UI

  if (Array.isArray(selected)) {
    // Multi select (CXO)
    const ids = selected.map(item => item.value.split(";")[0]); // just ID part
    setSelectedUserIds(ids);
  } else if (selected) {
    // Single select (SH/SM)
    setSelectedUserIds([selected.value.split(";")[0]]);
  } else {
    setSelectedUserIds([]);
  }
  };

  const handleServiceCategoryChange = (selected) => {
    setBaServiceCategory(selected);
    if (!selected) {
      setBaSharingRatio(null);
      return;
    }
    const mappedRatio = sharingRatioOptions.find((item) => item.value === selected.ratioValue) || null;
    setBaSharingRatio(mappedRatio);
  };

const downloadExcel = () => {

 if(filteredStaff.length === 0){
   alert("No data to download");
   return;
 }

 let csv = "Name,Phone,Email,Post\n";

 filteredStaff.forEach(item => {
   csv += `${item.name},${item.phone},${item.email},${item.post}\n`;
 });

 const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

 const link = document.createElement("a");
 const url = URL.createObjectURL(blob);

 link.href = url;
 link.download = "staff_list.csv";
 link.click();
};

  return (
    <>
      <button data-bs-toggle="modal" id="tera_modal" data-bs-target="#exampleModalFullscreen" type="button" style={{ display: 'none' }}></button>
      <div className="modal fade effect-fall" id="exampleModal" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="exampleModalLabel" style={{ display: 'none' }} aria-hidden="true">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h6 className="modal-title" id="exampleModalLabel1">Add Staff</h6>
              <button type="button" className="btn-close" data-bs-dismiss="modal" id="modalclose" aria-label="Close"></button>
            </div>
            <form id="submitform" onSubmit={FormSubmit}>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-lg-6" >
                    {/* Category Input */}
                    <label htmlFor="name" className="form-label">Name</label>
                    <input id="name" name="name" className="form-control" autoComplete='off' placeholder='Staff Name' required defaultValue="" />
                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="mobile" className="form-label">Mobile No.</label>
                    <input id="mobile" name="mobile" className="form-control" maxLength={10} minLength={10} autoComplete='off' placeholder='Mobile No.' inputMode='numeric' required defaultValue="" />
                  </div>
                  <div className="col-lg-6" >
                    {/* Category Input */}
                    <label htmlFor="email" className="form-label">Email</label>
                    <input id="email" name="email" type="email" className="form-control" autoComplete='off' placeholder='Email adddress' required defaultValue="" />
                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="post" className="form-label">Designation</label>
                    <Select
  options={uniquepost}
  value={selectedpost}
  onChange={handleDesignationChange}
  placeholder="Select Designation"
  menuPortalTarget={document.body}
  styles={{
    menuPortal: base => ({ ...base, zIndex: 9999 })
  }}
/>
                  </div>
     
      {statusData && (
        <div className="col-12 mt-3">
          <label htmlFor="users" className="form-label">
            {selectedpost?.value === "sourcing_head" ? "Select Sourcing Manager" : selectedpost?.value==="sourcing_manager" ? "Select Recruiter": selectedpost?.value=="cxo" ? "Select Sourcing head" : selectedpost?.value==="executive_manager" ? "Select Executive" : ''}
          </label>
          <Select options={userOptions} value={selectedUsers}  onChange={handleUserChange} isMulti closeMenuOnSelect={true}
            placeholder={selectedpost?.value === "sourcing_head" ? "Select Sourcing Manager" : selectedpost?.value==="sourcing_manager" ? "Select Recruiter": selectedpost?.value=="cxo" ? "Select Sourcing head" : selectedpost?.value==="executive_manager" ? "Select Executive" : ''}
          />
        </div>
      )}

  {isBusinessAssociate && (
        <>
          <div className="col-lg-6">
            <label htmlFor="bank_account_no" className="form-label">Bank Account No.</label>
            <input
              id="bank_account_no"
              name="bank_account_no"
              className="form-control"
              autoComplete="off"
              placeholder="Enter Bank Account No."
              value={baBankAccountNo}
              onChange={(e) => setBaBankAccountNo(e.target.value.replace(/\D/g, ""))}
              maxLength={18}
              required
            />
          </div>
          <div className="col-lg-6">
            <label htmlFor="ifsc_code" className="form-label">IFSC Code</label>
            <input
              id="ifsc_code"
              name="ifsc_code"
              className="form-control text-uppercase"
              autoComplete="off"
              placeholder="Enter IFSC Code"
              value={baIfscCode}
              onChange={(e) => setBaIfscCode(e.target.value.toUpperCase())}
              maxLength={11}
              required
            />
          </div>
          <div className="col-lg-6">
            <label htmlFor="service_category" className="form-label">Service Category</label>
            <Select
              inputId="service_category"
              options={serviceCategoryOptions}
              value={baServiceCategory}
              onChange={handleServiceCategoryChange}
              formatOptionLabel={formatSelectWithThumb}
              placeholder="Select Service Category"
              classNamePrefix="react-select"
              required
            />
          </div>
          <div className="col-lg-6">
            <label htmlFor="sharing_ratio" className="form-label">Sharing Ratio</label>
            <Select
              inputId="sharing_ratio"
              options={sharingRatioOptions}
              value={baSharingRatio}
              onChange={setBaSharingRatio}
              formatOptionLabel={formatSelectWithThumb}
              placeholder="Select Sharing Ratio"
              classNamePrefix="react-select"
              required
            />
          </div>
        </>
      )}
                  <div className="col-lg-6" >
                    {/* Category Input */}
                    <label htmlFor="password" className="form-label">Password</label>
                    <div className="input-group">
                      <input type={passwordVisibility.isVisible ? 'text' : 'password'} className="form-control form-control-lg" id="password" placeholder="Password" name="password" />
                      <button className="btn btn-light" onClick={passwordVisibility.toggleVisibility} type="button" id="button-addon2"><i className={passwordVisibility.isVisible ? 'ri-eye-line align-middle' : 'ri-eye-off-line align-middle'}></i></button>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <label htmlFor="confirm" className="form-label">Confirm Password</label>
                    <div className="input-group">
                      <input type={passwordVisibility2.isVisible ? 'text' : 'password'} className="form-control form-control-lg" id="confirm" placeholder="Re-enter Password" name="confirm" />
                      <button className="btn btn-light" onClick={passwordVisibility2.toggleVisibility} type="button" id="button-addon3  "><i className={passwordVisibility.isVisible ? 'ri-eye-line align-middle' : 'ri-eye-off-line align-middle'}></i></button>
                    </div>
                  </div>
                  <div className="col-lg-12" style={{ textAlign: 'right' }}>
                    <input type="hidden" name="hidden" id="hidden" />
                    <input type="reset" name="reset" id="reset" className="btn btn-danger" style={{ marginRight: '20px', display: 'none' }} />
                  </div>
                </div>

              </div>
              <div className='modal-footer' style={{ padding: '0px' }}>
                <button type="submit" className="btn btn-primary">Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className="modal fade effect-sign" id="exampleModalFullscreen" tabIndex="-1" aria-labelledby="exampleModalFullscreenLabel" aria-hidden="true" style={{ display: 'none' }}>
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            <div className="modal-header" style={{paddingTop:'0px',paddingBottom:'10px'}}>

<span className="about-heading fs-20 text-dark fw-semibold mb-0">ACCESS FOR :- {userss}</span>
<button type="button" className="btn fs-23 text-danger" style={{marginTop:'6px'}} data-bs-dismiss="modal">X</button>

            </div>
          <div className="modal-body">

              <div className="row gy-2">

                 
      {app.map((pro) => {
        
        const isAddOn  =  pro.addd ==true || changes[`${pro.id}_add`];
        const isEditOn =  pro.edit ==true || changes[`${pro.id}_edit`];
        const isDelOn  =  pro.del ==true || changes[`${pro.id}_del`];
        const isViewOn =  pro.view ==true || changes[`${pro.id}_view`];
 
                        
return(
<div className="col-xxl-3 col-xl-3 col-lg-4 col-md-6 col-sm-12" key={pro.id}>
    <div className="card custom-card text-center">
        <div className="card-body pb-3">

                           <input type="hidden" name="appid[]" value={pro.id} />
                            <input type="hidden" name="appname[]" value={pro.name} />
          
            <span className="avatar avatar-xl bg-outline-primary mb-2"> <i className={pro.icon+" fs-52"}></i> </span>
            <p className="fw-semibold fs-18 mb-0">{pro.name.toUpperCase()}</p>
        </div>
        <div className="card-footer pt-2">

         <div className="d-flex justify-content-between px-2 mb-1">
              
              <div className="fs-18 text-dark fw-semibold">Add</div>
              <div className="fs-18 text-dark fw-semibold">Edit</div>
              <div className="fs-18 text-dark fw-semibold">Delete</div>
              <div className="fs-18 text-dark fw-semibold">View</div>

          </div>

      <div style={{ display: "flex", gap: "45px" }}>
              {/* Add */}
              <div
                className={`toggle toggle-primary mb-3 ${isAddOn ? "on" : ""}`}
                onClick={() => handleToggle(pro.id, !isAddOn, 1)}
              >
                <span></span>
              </div>
              {/* Edit */}
              <div
                className={`toggle toggle-primary mb-3 ${isEditOn ? "on" : ""}`}
                onClick={() => handleToggle(pro.id, !isEditOn, 2)}
              >
                <span></span>
              </div>
              {/* Delete */}
              <div
                className={`toggle toggle-primary mb-3 ${isDelOn ? "on" : ""}`}
                onClick={() => handleToggle(pro.id, !isDelOn, 3)}
              >
                <span></span>
              </div>
              {/* View */}
              <div
                className={`toggle toggle-primary mb-3 ${isViewOn ? "on" : ""}`}
                onClick={() => handleToggle(pro.id, !isViewOn, 4)}
              >
                <span></span>
              </div>
            </div>


        </div>
    </div>
</div>
)
                      }
                    )}
               

              </div>



            </div>
            <div className="modal-footer">
              <input type='hidden' id='sid' value={sid}/>
              <button type="button" className="btn btn-secondary appCloseModal" data-bs-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>

      <div className="main-content app-content">

        <div className="container-fluid">
          <div className="row">
 
<div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-6 mb-4 mt-4">
<div className="card custom-card mb-0">
    <div className="card-body" style={{padding:'13px'}}>
        <div className="d-flex align-items-center flex-wrap gap-2">
            <h5 className="fw-semibold mb-0 flex-grow-1"><span className="fw-normal fs-18 text-dark fw-semibold">Our Staff <span className='badge bg-success'>Total :{filteredStaff.length}</span></span></h5>
    
           
            <div className="btn-group" style={{width:'25%'}}>
              <input type="search" className="form-control" placeholder="Search Staff user" onChange={handleChange}/>
   <div style={{minWidth:'200px'}}> 
<Select
  options={uniquepost}
  placeholder="Filter Post"
  isClearable
  onChange={(e)=>setPostFilter(e)}
/>
</div>

        
            </div>

             <button className="btn btn-primary ms-2" data-bs-toggle="modal" data-bs-target="#exampleModal" id='addStaffbtn'>Add Staff</button>
             <button className="btn btn-primary ms-2" data-bs-toggle="offcanvas" data-bs-target="#vendorAddModal">Add Vendor</button>
<button
 className="btn btn-success ms-2"
 onClick={downloadExcel}
>
Download Staff
</button>
        </div>
      
    {stats.length > 0 && (
  <div className="row gy-md-0 gy-3 mt-2">

    {stats.map((item, index) => (

      <div className="col-xxl-2 col-xl-2 col-lg-4 col-md-4 col-sm-12" key={index}>
        <div className="d-flex align-items-top">
          <div className="me-3">
            <span
              className="avatar avatar-rounded text-white"
              style={{ backgroundColor: item.color }}
            >
              <i className={`${item.icon} fs-28`}></i>
            </span>
          </div>

          <div>
            <span className="d-block mb-1 text-muted">{item.label}</span>
            <h6 className="fw-semibold mb-0">{item.count}</h6>
          </div>
        </div>
      </div>
    ))}

  </div>
)}
    </div>
</div>
</div>

<div style={{ textAlign: 'center' }}>
  {loading && (
    <div id="searchLoader" className="lds-ellipsis" style={{ color: '#333' }}>
      <div></div><div></div><div></div><div></div>
    </div>
  )}
</div> 

<div id="noDataMessage" style={{ textAlign: 'center', marginTop: '1rem', display: 'none' }}>
  <p className="text-muted">No records found</p>
</div>

 {filteredStaff.map((pro, index) => (
  <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 col-sm-6 staff-card">
                  <div className="card custom-card">
                                    <div className="card-body" style={{paddingBottom:'15px'}}>
                                        <div className="btn-list float-end">
                                            <button className="btn btn-danger-light btn-sm me-2"  onClick={() => { DeleteData(pro.id) }} data-tooltip-id="global-tooltip" data-tooltip-content="Delete" data-bs-placement="top" ><span><i className="ri-delete-bin-line fs-14"></i></span></button>
                                            <button className="btn btn-primary-light btn-sm"  onClick={() => { EditData(pro.id) }} data-tooltip-id="global-tooltip" data-bs-placement="top" data-tooltip-content="Edit"><span><i className="ri-edit-line fs-14"></i></span></button>
                                        </div>
                                        <div className="d-flex align-items-center flex-wrap gap-2">
                                           <span className="avatar avatar-lg avatar-rounded bg-primary bg-opacity-75 border">{pro.short}</span>

                                            <div className="ms-2">
                                                <h5 className="fw-semibold mb-0 d-flex align-items-center gap-2 search-value">{pro.name} <i className={pro.status=='Active' ? "bi bi-check-circle-fill text-success" :"ri-close-line text-danger fs-16"} data-tooltip-id="global-tooltip" data-tooltip-content={pro.status}></i> </h5>
                                                <div className="d-flex gap-3 mt-2">
                                                    <a href={"mailto:"+pro.email} className="search-value"><i className="ri-mail-settings-fill fs-15"></i> {pro.email}</a>
                                                </div> 
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-footer" style={{paddingTop:'15px'}}>
                                        <div className="d-flex align-items-center flex-wrap gap-2">
                                            <div className="flex-grow-1">
                                                <span className="badge badge-lg p-2 bg-primary-transparent fs-14 search-value" data-tooltip-id="global-tooltip" data-tooltip-content="Post"><i className="ri-stack-fill me-1"></i>{pro.post}</span>
                                            </div>
                                           <a href={"tel:+91"+pro.phone} className="search-value"><i className="ri-phone-fill fs-15"></i> {pro.phone} </a>
                                        </div>
                                    </div>
                                </div>
                </div>
 ))}

      </div>
        </div>
      </div>

      <VendorCopy
        embedOnly
        aidOverride={vendorAid}
        modalId="vendorAddModal"
        addButtonId="vendorAddModalBtn"
      />

    </>
  );

};
export default Sub_category;
